import axios from 'Axios';
import { SWRConfig } from 'swr';
// import { MarkerProvider, PlayerProvider, SidebarProvider } from 'Context';
import { RefProvider } from 'react-context-refs';

export const ContextLayout = ({ children }) => {
	const fetcher = (url) => axios.get(url).then((res) => res.data);
	return (
		<SWRConfig
			value={{
				fetcher,
				refreshWhenOffline: true
			}}>
			<RefProvider>{children}</RefProvider>
		</SWRConfig>
	);
};
